import {ValueObject} from '@s-ui/domain'

import {ConfigContext} from '../../config/context/index.js'
import {ConfigurationFieldsValueObject} from './ConfigurationFieldsValueObject.js'

const NOT_FOUND_INDEX = 999

export class GetLeadConfigurationResponseValueObject extends ValueObject {
  #fields

  static FIELD_ORDER = ['NAME', 'EMAIL', 'PHONE', 'ZIP_CODE', 'OEM_LEGAL_CONSENTS']

  constructor({fields}) {
    super()
    this.#fields = this._sortFieldsByOrder(fields)
  }

  _sortFieldsByOrder(fields) {
    return fields.sort((a, b) => {
      const indexA = GetLeadConfigurationResponseValueObject.FIELD_ORDER.indexOf(a.id)
      const indexB = GetLeadConfigurationResponseValueObject.FIELD_ORDER.indexOf(b.id)

      // If a field is not found in the order array, push it to the end
      const orderA = indexA === -1 ? NOT_FOUND_INDEX : indexA
      const orderB = indexB === -1 ? NOT_FOUND_INDEX : indexB

      return orderA - orderB
    })
  }

  static createDefault(variationKey) {
    const {FORM_FIELD_IDS} = ConfigContext.get('configurator')
    const defaultFields = [FORM_FIELD_IDS.ZIP_CODE]

    return new GetLeadConfigurationResponseValueObject({
      fields: defaultFields.map(id => {
        return ConfigurationFieldsValueObject.createFromApi({id})
      })
    })
  }

  static createFromApi({fields: apiFields = []}, variationKey) {
    const {VEHICLE_CONFIGURATOR_FIELDS_CONFIG, FORM_FIELD_IDS} = ConfigContext.get('configurator')
    const validFields = [...apiFields.filter(field => VEHICLE_CONFIGURATOR_FIELDS_CONFIG[field.id])]

    // If the configuration from the server does not include the zip code, we add it as required
    if (!validFields.some(field => field.id === FORM_FIELD_IDS.ZIP_CODE)) {
      validFields.push({id: FORM_FIELD_IDS.ZIP_CODE, required: true})
    }

    return new GetLeadConfigurationResponseValueObject({
      fields: validFields.map(field => {
        return ConfigurationFieldsValueObject.createFromApi({
          id: field.id,
          isRequired: field.required,
          label: field.label,
          type: field.type
        })
      })
    })
  }

  get fields() {
    return this.#fields
  }

  isEmpty() {
    return this.#fields.length === 0
  }

  hasPhoneField() {
    return this.#fields.some(field => field.id === 'PHONE')
  }

  isPhoneRequired() {
    return this.#fields.some(field => field.id === 'PHONE' && field.isRequired)
  }

  isZipCodeRequired() {
    return this.#fields.some(field => field.id === 'ZIP_CODE' && field.isRequired)
  }

  hasNameField() {
    return this.#fields.some(field => field.id === 'NAME')
  }

  isNameRequired() {
    return this.#fields.some(field => field.id === 'NAME' && field.isRequired)
  }

  hasEmailField() {
    return this.#fields.some(field => field.id === 'EMAIL')
  }

  isEmailRequired() {
    return this.#fields.some(field => field.id === 'EMAIL' && field.isRequired)
  }
}
